export default __webpack_public_path__ + "static/media/hand_right.0d77873f.png";